import React from "react";
import styles from "../styles/habitaciones.module.css"; // ajusta ruta si tu css está en otro sitio

export default function HabitacionesFilters({
    query,
    estado,
    onChangeQuery,
    onChangeEstado,
    onClickNew,
}) {
    return (
        <div className={`${styles["filters-row"]} ${styles.card}`}>
            <input
                className={styles.input}
                placeholder="Buscar por nombre, descripción o comentarios…"
                value={query}
                onChange={(e) => onChangeQuery(e.target.value)}
            />

            <select
                className={styles.input}
                value={estado}
                onChange={(e) => onChangeEstado(e.target.value)}
            >
                <option value="todos">Todas</option>
                <option value="libres">Disponibles</option>
                <option value="ocupadas">No disponibles</option>
            </select>

            <div className={styles["actions-row"]}>
                <button
                    className={`${styles.btn} ${styles.primary}`}
                    type="button"
                    onClick={onClickNew}
                >
                    + Nueva habitación
                </button>
            </div>
        </div>
    );
}
